interface TopStoresChartProps {
  data: Array<{
    storeName: string;
    cityName: string;
    avgScore: number;
    totalReports: number;
  }>;
  title?: string;
}

export const TopStoresChart: React.FC<TopStoresChartProps> = ({
  data,
  title = 'Top 10 Puntos de Venta',
}) => {
  // Limitar a los primeros 10 y ordenar
  const topData = data
    .sort((a, b) => b.avgScore - a.avgScore)
    .slice(0, 10)
    .map((item) => ({
      ...item,
      shortName:
        item.storeName.length > 20
          ? item.storeName.substring(0, 20) + '...'
          : item.storeName,
    }));

  const getBarColor = (score: number) => {
    if (score >= 80) return '#10b981'; // green
    if (score >= 50) return '#f59e0b'; // yellow
    return '#ef4444'; // red
  };

  return (
    <div className="bg-white p-3 sm:p-4 md:p-6 rounded-lg shadow-sm">
      <h3 className="text-base sm:text-lg md:text-xl font-semibold mb-3 sm:mb-4 text-gray-800">
        {title}
      </h3>
      <div className="space-y-3">
        {topData.map((store, index) => (
          <div key={index} className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center bg-gray-100 rounded-full text-sm font-medium text-gray-700">
              {index + 1}
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-1 gap-2">
                <div className="min-w-0 flex-1">
                  <div className="font-medium text-gray-900 text-xs sm:text-sm truncate">
                    {store.storeName}
                  </div>
                  <div className="text-[10px] sm:text-xs text-gray-500">
                    {store.cityName} • {store.totalReports} reportes
                  </div>
                </div>
                <div
                  className="text-base sm:text-lg font-bold flex-shrink-0"
                  style={{
                    color: getBarColor(store.avgScore),
                  }}
                >
                  {store.avgScore.toFixed(1)}%
                </div>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className="h-2 rounded-full transition-all duration-300"
                  style={{
                    width: `${store.avgScore}%`,
                    backgroundColor: getBarColor(store.avgScore),
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
      {topData.length === 0 && (
        <div className="text-center text-gray-500 py-8">
          No hay datos disponibles
        </div>
      )}
    </div>
  );
};
